export default "__VITE_ASSET__36f1f6ed__"